import React, {Component, Fragment} from 'react';
import {Helmet} from 'react-helmet';
import EventsSearch from './EventsSearch';
import EventsList from './EventsList';

class EventsListContainer extends Component {
    render() {
        return (
            <Fragment>
                <Helmet
                    bodyAttributes={{
                        class: 'events'
                    }}
                >
                    <title>{'Evénements' + ' ' + process.env.REACT_APP_HEAD_TITLE_SEPARATOR + ' ' + process.env.REACT_APP_SITE_TITLE}</title>
                </Helmet>
                <div className="container">
                    <EventsSearch/>
                    <EventsList/>
                </div>
            </Fragment>
        );
    }
}

export default EventsListContainer;



// WEBPACK FOOTER //
// ./src/features/Events/components/List/EventsListContainer.js